import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Select from "@/components/elements/Select.vue";
import countries from "@/lib/countries";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectCountries',
  emits: ["change"],
  setup(__props, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Select, {
      items: _unref(countries),
      label: "Country",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event.value)))
    }, null, 8, ["items"])
  ]))
}
}

})